/**
 * HeroNoise — fractal noise overlay drawn with feTurbulence.
 * Used as a subtle film-grain texture over the hero video.
 */
export default function HeroNoise() {
  return (
    <svg
      className="absolute inset-0 w-full h-full pointer-events-none mix-blend-overlay opacity-50"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
    >
      <filter id="hero-noise">
        <feTurbulence type="fractalNoise" baseFrequency="0.85" numOctaves="3" stitchTiles="stitch" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0  0 0 0 0 0  0 0 0 0 0  0 0 0 0.08 0"
        />
      </filter>
      <rect width="100%" height="100%" filter="url(#hero-noise)" />
    </svg>
  );
}
